export { DEFAULT };

const DEFAULT = {
  mobiles: '360px',
  mobile: '480px',
  mobilel: '600px',
  tablet: '768px',
  tabletl: '1024px',
  laptop: '1280px',
  laptopl: '1440px',
  desktop: '1600px',
  desktop1k: '1920px',
  desktop2k: '2560px',
};
